import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DropDownComponentBase } from './drop-down.base.component';

import { CommonService } from '../../_services';
import { IRegion, ICountry } from '../../_entities';

@Component({
    selector: 'own-region-dropdown',
    template: require('../../shared/components/dropdown.template.html'),
    styles: ['input[type=text] { margin-top:10px; }']
})
export class OwnRegionDropDownComponent extends DropDownComponentBase<IRegion> {
    private country: ICountry;
    private regions: IRegion[];

    constructor(private commonService: CommonService) {
        super();
    }

    ngOnInit() {
        this.isDisabled = !this.country;
    }

    getItems(): Promise<IRegion[]> {
        if (!this.country) {
            return null;
        }

        if (this.regions) {
            return Promise.resolve(this.regions.filter(x => x.country.code === this.country.code));
        }

        return this.commonService.getRegions()
            .then(regions => {
                this.regions = regions;
                return regions.filter(x => x.country.code === this.country.code);
            });
    }
    mapItem(items: IRegion[], item: IRegion): IRegion {
        return items.find(x => x.country.code === item.country.code && x.name === item.name);
    }
    onItemSelected(item: IRegion) {
        this.selectedItemChange.emit(item);
    }

    @Input("country") set countryBinding(val: ICountry) {
        if ((!this.country && val) || (val && val.code !== this.country.code)) {
            this.country = val;
        } else if (!val) {
            this.country = null;
        }
        this.updateItemList();
        if (!this.country || (this.selectedItem && this.country.code !== this.selectedItem.country.code)) {
            this.setSelectedItem(null);
        }
        this.isDisabled = !this.country;
    }
    @Input("selectedRegion") set selectedItemBinding(val: IRegion) {
        if (val != this.selectedItem)
            this.setSelectedItem(val);
    }
    @Output("selectedRegionChange") selectedItemChange = new EventEmitter<IRegion>();
    
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/own-region-dropdown.component.ts